export const machineProductionUtilizationChartData: {
  [key: string]: {
    production: number[];
    utilization: number[];
  };
} = {
  1: {
    production: [
      56, 85, 53, 73, 76, 62, 150, 150, 145, 123, 133, 80, 121, 107, 101, 83, 112, 53, 130, 58, 118,
      86, 52, 125, 150, 97, 148, 101, 72, 111,
    ],
    utilization: [
      94.4, 51.1, 87.3, 66.6, 55.4, 60.7, 50.6, 98.8, 63.2, 68.9, 88.4, 82.9, 65.8, 62.6, 96.9,
      69.1, 66.8, 50.9, 79.0, 80.8, 64.5, 63.0, 95.2, 99.3, 69.4, 91.1, 65.9, 61.2, 83.3, 91.0,
    ],
  },
  2: {
    production: [
      63, 135, 73, 69, 74, 99, 96, 72, 95, 101, 58, 141, 123, 137, 148, 136, 112, 90, 79, 149, 51,
      126, 70, 141, 59, 62, 109, 98, 122, 99,
    ],
    utilization: [
      57.7, 93.9, 80.0, 63.0, 83.7, 75.0, 97.1, 65.5, 89.7, 76.2, 81.3, 86.3, 79.9, 56.4, 53.7,
      51.3, 72.2, 99.3, 76.5, 57.6, 81.9, 94.8, 94.9, 93.3, 67.8, 71.9, 55.1, 61.6, 100.0, 66.5,
    ],
  },
  3: {
    production: [
      113, 94, 140, 104, 78, 96, 81, 70, 67, 146, 93, 119, 130, 115, 92, 109, 65, 138, 107, 88, 100,
      106, 106, 150, 81, 134, 82, 138, 150, 98,
    ],
    utilization: [
      94.4, 88.7, 70.4, 51.6, 86.8, 58.1, 94.4, 75.0, 96.9, 53.0, 92.7, 70.5, 59.1, 91.9, 71.4,
      57.2, 62.0, 96.3, 52.5, 59.2, 59.7, 57.3, 82.1, 68.4, 98.2, 80.8, 83.2, 64.2, 68.8, 89.7,
    ],
  },
  4: {
    production: [
      115, 130, 84, 136, 97, 64, 116, 58, 129, 94, 144, 146, 63, 79, 117, 128, 97, 63, 109, 95, 53,
      139, 55, 118, 80, 138, 95, 96, 66, 119,
    ],
    utilization: [
      67.9, 60.5, 63.5, 73.6, 75.1, 69.7, 55.7, 52.4, 75.1, 83.7, 68.4, 60.4, 94.8, 78.5, 91.8,
      99.5, 69.7, 99.8, 87.3, 83.9, 76.4, 91.8, 59.8, 58.4, 67.2, 68.2, 96.2, 71.5, 62.9, 78.4,
    ],
  },
  5: {
    production: [
      136, 50, 85, 101, 115, 139, 117, 75, 88, 79, 119, 114, 88, 103, 68, 88, 128, 78, 138, 133,
      148, 70, 78, 69, 108, 115, 59, 84, 143, 149,
    ],
    utilization: [
      52.1, 77.4, 97.1, 90.7, 78.9, 59.5, 91.2, 51.2, 85.0, 83.9, 68.1, 90.3, 86.0, 68.5, 57.2,
      79.0, 63.2, 79.6, 55.0, 59.0, 77.7, 68.2, 91.9, 66.8, 73.2, 74.5, 84.4, 69.0, 77.9, 72.6,
    ],
  },
  6: {
    production: [
      105, 68, 95, 80, 102, 71, 106, 60, 79, 108, 104, 62, 148, 93, 129, 122, 96, 129, 100, 143,
      118, 104, 50, 81, 130, 148, 129, 85, 70, 131,
    ],
    utilization: [
      82.6, 62.1, 81.2, 81.7, 98.0, 82.6, 92.9, 97.5, 76.0, 67.6, 77.8, 95.9, 61.1, 87.6, 52.6,
      90.5, 68.2, 53.0, 76.6, 68.6, 61.1, 94.4, 73.8, 62.5, 98.2, 82.0, 78.8, 73.8, 72.9, 70.3,
    ],
  },
  7: {
    production: [
      134, 88, 62, 106, 59, 104, 114, 109, 113, 90, 106, 99, 93, 103, 119, 125, 110, 50, 65, 92, 88,
      80, 77, 128, 115, 148, 149, 142, 116, 78,
    ],
    utilization: [
      65.1, 72.8, 98.7, 58.1, 89.4, 79.1, 57.0, 78.2, 57.7, 84.6, 62.8, 78.2, 82.9, 92.3, 72.2,
      99.7, 56.8, 75.5, 82.9, 58.0, 83.5, 99.5, 53.9, 67.7, 73.3, 67.2, 69.9, 96.6, 86.5, 66.9,
    ],
  },
  8: {
    production: [
      75, 65, 52, 63, 127, 139, 99, 57, 104, 88, 58, 64, 79, 135, 100, 103, 56, 63, 144, 71, 51,
      116, 139, 52, 131, 132, 132, 72, 91, 87,
    ],
    utilization: [
      59.7, 56.9, 68.9, 52.5, 86.4, 78.8, 51.5, 57.6, 86.3, 90.8, 74.2, 52.7, 71.3, 64.1, 75.0,
      67.1, 87.1, 65.1, 99.0, 63.7, 95.8, 82.4, 76.1, 69.3, 99.4, 89.5, 62.5, 97.6, 77.3, 64.1,
    ],
  },
  9: {
    production: [
      137, 77, 109, 131, 55, 147, 56, 92, 113, 122, 111, 58, 111, 91, 134, 65, 141, 127, 119, 59,
      127, 102, 138, 105, 96, 95, 84, 63, 82, 98,
    ],
    utilization: [
      97.0, 71.5, 74.4, 63.8, 98.9, 81.1, 85.7, 63.3, 53.7, 80.2, 67.4, 57.8, 78.9, 85.7, 50.3,
      69.6, 77.9, 52.7, 71.6, 96.9, 66.0, 51.8, 62.5, 50.0, 63.5, 71.6, 57.2, 53.7, 81.9, 63.8,
    ],
  },
  10: {
    production: [
      109, 141, 60, 148, 86, 130, 83, 121, 74, 90, 67, 119, 85, 134, 94, 135, 123, 105, 60, 84, 79,
      63, 143, 131, 146, 87, 74, 66, 73, 100,
    ],
    utilization: [
      70.7, 91.0, 99.6, 52.8, 65.3, 61.5, 72.0, 72.7, 54.9, 79.0, 94.7, 51.8, 60.8, 60.2, 81.5,
      67.8, 90.6, 58.4, 55.2, 71.3, 94.8, 89.5, 99.1, 99.8, 95.2, 99.6, 64.7, 67.0, 85.9, 76.2,
    ],
  },
  11: {
    production: [
      110, 140, 148, 75, 132, 64, 90, 106, 63, 146, 71, 53, 77, 129, 77, 93, 105, 111, 78, 142, 150,
      142, 92, 61, 60, 130, 127, 99, 135, 141,
    ],
    utilization: [
      89.9, 93.1, 63.0, 77.7, 79.0, 71.2, 81.9, 67.5, 50.5, 89.9, 68.4, 64.8, 68.8, 50.0, 62.7,
      76.5, 69.8, 82.8, 58.7, 68.8, 54.1, 85.2, 91.1, 96.6, 97.7, 98.3, 55.0, 97.9, 92.0, 56.3,
    ],
  },
  12: {
    production: [
      118, 107, 73, 79, 63, 137, 93, 53, 131, 93, 96, 134, 73, 87, 126, 129, 113, 68, 102, 127, 98,
      51, 115, 94, 57, 128, 60, 100, 74, 114,
    ],
    utilization: [
      56.0, 92.4, 94.2, 54.9, 96.5, 69.3, 66.0, 97.7, 94.1, 54.4, 93.7, 51.6, 68.4, 76.6, 82.2,
      84.5, 53.1, 83.1, 59.6, 74.2, 92.1, 70.0, 84.9, 88.4, 65.1, 60.4, 66.9, 81.1, 55.7, 66.2,
    ],
  },
  13: {
    production: [
      116, 72, 89, 54, 64, 64, 54, 145, 142, 85, 139, 117, 83, 120, 114, 79, 129, 110, 110, 87, 79,
      114, 123, 88, 119, 122, 120, 60, 140, 127,
    ],
    utilization: [
      73.7, 61.7, 76.9, 82.6, 73.8, 91.9, 55.4, 86.0, 69.8, 87.4, 66.4, 73.6, 58.5, 63.4, 60.1,
      69.6, 80.7, 65.3, 80.3, 68.9, 56.8, 50.6, 85.3, 77.2, 96.2, 86.3, 98.6, 55.6, 66.7, 53.6,
    ],
  },
  14: {
    production: [
      137, 105, 145, 53, 59, 110, 123, 144, 143, 70, 147, 127, 60, 118, 150, 84, 107, 98, 64, 129,
      85, 135, 71, 54, 81, 139, 115, 141, 62, 85,
    ],
    utilization: [
      67.0, 86.9, 82.5, 70.7, 66.1, 91.3, 54.5, 79.7, 96.3, 64.0, 64.4, 51.8, 68.0, 80.7, 75.1,
      52.7, 83.6, 77.8, 76.2, 56.5, 90.4, 80.1, 89.6, 61.1, 50.1, 73.0, 85.1, 84.7, 62.0, 64.2,
    ],
  },
  15: {
    production: [
      124, 69, 54, 96, 82, 97, 147, 120, 121, 149, 91, 83, 93, 69, 99, 102, 137, 67, 63, 95, 70, 84,
      120, 117, 136, 115, 53, 110, 107, 139,
    ],
    utilization: [
      79.8, 86.6, 98.2, 70.0, 97.5, 70.8, 86.5, 62.9, 82.3, 92.6, 66.3, 58.2, 70.0, 57.9, 89.4,
      96.4, 54.0, 80.1, 86.0, 92.4, 88.3, 74.1, 91.8, 67.9, 81.9, 66.8, 77.7, 57.4, 59.5, 83.3,
    ],
  },
  16: {
    production: [
      123, 61, 129, 85, 76, 100, 82, 53, 138, 79, 115, 99, 135, 113, 143, 146, 88, 103, 60, 132,
      124, 90, 118, 112, 119, 101, 140, 123, 143, 52,
    ],
    utilization: [
      62.5, 92.9, 54.8, 50.7, 60.6, 54.7, 85.1, 87.1, 72.6, 65.7, 86.6, 93.9, 81.0, 71.8, 92.1,
      57.6, 66.3, 95.2, 62.7, 79.6, 54.5, 72.1, 68.4, 50.3, 56.8, 98.3, 59.5, 89.5, 50.9, 59.8,
    ],
  },
  17: {
    production: [
      130, 144, 56, 148, 149, 65, 82, 83, 106, 140, 144, 133, 93, 112, 82, 83, 82, 105, 114, 114,
      97, 95, 65, 129, 53, 85, 127, 53, 92, 50,
    ],
    utilization: [
      84.2, 92.5, 58.2, 90.0, 55.9, 89.4, 51.6, 53.9, 74.4, 69.0, 54.9, 54.2, 66.7, 76.8, 95.5,
      91.1, 77.5, 68.1, 68.3, 65.9, 96.1, 82.7, 52.3, 63.1, 87.6, 68.2, 99.2, 67.5, 77.8, 69.8,
    ],
  },
  18: {
    production: [
      94, 88, 92, 134, 148, 51, 137, 84, 128, 104, 133, 71, 127, 68, 126, 143, 118, 66, 89, 60, 96,
      123, 113, 116, 122, 54, 57, 102, 83, 105,
    ],
    utilization: [
      91.7, 60.9, 83.3, 73.7, 67.3, 70.5, 96.8, 61.2, 70.1, 84.8, 66.8, 69.5, 99.2, 71.5, 51.2,
      76.5, 67.5, 93.6, 64.7, 60.1, 54.0, 81.8, 73.4, 61.3, 98.1, 58.7, 80.9, 61.9, 80.4, 93.7,
    ],
  },
  19: {
    production: [
      135, 124, 100, 93, 75, 148, 96, 132, 124, 84, 112, 88, 70, 98, 106, 124, 133, 130, 125, 100,
      139, 115, 147, 87, 87, 91, 63, 62, 121, 67,
    ],
    utilization: [
      74.9, 50.6, 77.3, 75.1, 50.5, 55.6, 69.8, 54.2, 50.9, 88.4, 72.0, 90.3, 74.8, 56.8, 83.9,
      98.9, 94.9, 77.2, 58.5, 99.4, 88.0, 65.0, 74.8, 58.7, 52.7, 69.6, 93.8, 64.0, 72.8, 90.3,
    ],
  },
  20: {
    production: [
      147, 79, 71, 71, 94, 82, 73, 92, 116, 88, 140, 76, 78, 139, 56, 120, 95, 101, 65, 143, 74,
      105, 103, 64, 54, 74, 121, 103, 131, 116,
    ],
    utilization: [
      97.6, 79.0, 57.2, 52.2, 87.0, 67.4, 54.6, 75.5, 61.3, 99.6, 63.6, 74.1, 97.7, 59.0, 66.1,
      95.8, 86.0, 53.9, 53.5, 70.1, 68.0, 69.7, 94.5, 57.4, 79.6, 97.9, 52.6, 79.8, 81.6, 84.0,
    ],
  },
};
